var _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgStep1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    fill: "#12e1b9",
    style: {
      fill: "rgb(239, 169, 107)"
    },
    viewBox: "0 0 500 410.3",
    original_string_length: 5065,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "__id18_sn7p50abis"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 0 71 L 500 71 L 500 410.261719 L 0 410.261719 Z M 0 71"
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M 327.753906 158.355469 L 328.78125 168.300781 C 332.070312 167.980469 335.476562 167.8125 338.90625 167.8125 C 341.738281 167.8125 344.660156 167.925781 347.582031 168.148438 L 348.375 158.183594 C 345.1875 157.941406 342.003906 157.820312 338.90625 157.820312 C 335.136719 157.820312 331.386719 158 327.753906 158.355469",
    style: {
      fill: "inherit"
    }
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M 288.390625 170.730469 L 293.566406 179.355469 C 298.925781 176.289062 304.632812 173.804688 310.523438 171.964844 L 307.40625 162.445312 C 300.800781 164.507812 294.402344 167.292969 288.390625 170.730469",
    style: {
      fill: "inherit"
    }
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M 151.574219 307.195312 C 158.324219 305.855469 164.96875 303.972656 171.320312 301.601562 L 167.660156 292.265625 C 161.832031 294.441406 155.734375 296.167969 149.53125 297.402344 L 151.574219 307.195312",
    style: {
      fill: "inherit"
    }
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M 257.671875 197.453125 L 265.71875 203.628906 C 269.742188 198.636719 274.054688 194.097656 278.539062 190.152344 L 271.679688 182.730469 C 266.765625 187.058594 262.054688 192.011719 257.671875 197.453125",
    style: {
      fill: "inherit"
    }
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M 111.703125 299.253906 L 110.792969 309.207031 C 115.363281 309.605469 119.941406 309.808594 124.398438 309.808594 C 126.679688 309.808594 128.972656 309.757812 131.21875 309.652344 L 130.734375 299.667969 C 128.648438 299.765625 126.515625 299.8125 124.398438 299.8125 C 120.242188 299.8125 115.972656 299.625 111.703125 299.253906",
    style: {
      fill: "inherit"
    }
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M 200.171875 273.691406 C 195.222656 277.652344 190.003906 281.214844 184.660156 284.273438 L 189.847656 292.894531 C 195.644531 289.570312 201.300781 285.714844 206.660156 281.425781 L 200.171875 273.691406",
    style: {
      fill: "inherit"
    }
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M 226.117188 246.507812 C 222.265625 251.667969 218.1875 256.527344 213.996094 260.945312 L 221.511719 267.738281 C 225.972656 263.03125 230.308594 257.867188 234.394531 252.390625 L 226.117188 246.507812",
    style: {
      fill: "inherit"
    }
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M 71.074219 301.097656 C 77.597656 303.167969 84.191406 304.894531 90.667969 306.234375 L 92.789062 296.457031 C 86.664062 295.1875 80.421875 293.554688 74.242188 291.589844 L 71.074219 301.097656",
    style: {
      fill: "inherit"
    }
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M 402.707031 183.109375 C 408.394531 185.621094 414.226562 188.46875 420.035156 191.570312 L 424.949219 182.800781 C 418.914062 179.578125 412.851562 176.617188 406.925781 174.003906 L 402.707031 183.109375",
    style: {
      fill: "inherit"
    }
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M 366.363281 170.949219 C 372.339844 172.257812 378.542969 173.992188 384.800781 176.109375 L 388.152344 166.664062 C 381.53125 164.425781 374.953125 162.585938 368.601562 161.195312 L 366.363281 170.949219",
    style: {
      fill: "inherit"
    }
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#__id18_sn7p50abis)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 371.878906 268.023438 L 366.402344 268.367188 L 362.371094 272.089844 L 294.238281 334.9375 L 230.941406 144.46875 L 298.289062 87.011719 L 392.988281 90.554688 L 442.832031 193.144531 C 442.640625 193.023438 442.445312 192.902344 442.253906 192.78125 L 436.769531 201.222656 C 441.710938 204.28125 446.640625 207.53125 451.453125 210.886719 L 476.007812 261.425781 Z M 402.84375 75.441406 L 292.839844 71.328125 L 219.328125 134.042969 L 201.164062 130.84375 C 198.792969 135.464844 196.195312 140.25 193.382812 145.179688 L 216.214844 149.203125 L 240.878906 223.414062 C 239.492188 225.933594 238.070312 228.40625 236.636719 230.796875 L 244.90625 235.539062 L 279.851562 340.695312 L 174.113281 335.863281 L 169.542969 335.652344 L 165.59375 337.964844 L 81.644531 387.078125 L 52.488281 293.285156 L 56.253906 284.902344 C 53.480469 283.714844 50.996094 282.574219 48.839844 281.539062 L 18.257812 183.160156 L 75.460938 146.21875 C 72.78125 141.550781 70.292969 137.015625 68.003906 132.621094 L 0 176.539062 L 72.652344 410.261719 L 173.40625 351.316406 L 293.351562 356.800781 L 372.859375 283.460938 L 500 275.40625 L 402.84375 75.441406",
    style: {
      fill: "inherit"
    }
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M 95.398438 66.617188 C 95.398438 45.230469 112.738281 27.890625 134.125 27.890625 C 155.511719 27.890625 172.851562 45.230469 172.851562 66.617188 C 172.851562 88.003906 155.511719 105.34375 134.125 105.34375 C 112.738281 105.34375 95.398438 88.003906 95.398438 66.617188 Z M 205.191406 71.0625 C 205.191406 31.8125 173.375 -0.00390625 134.125 -0.00390625 C 94.875 -0.00390625 63.054688 31.8125 63.054688 71.0625 C 63.054688 116.90625 134.125 206.523438 134.125 206.523438 C 134.125 206.523438 205.191406 116.90625 205.191406 71.0625",
    style: {
      fill: "inherit"
    }
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStep1);
export default __webpack_public_path__ + "static/media/step1.955e7dc6926ce10b3301ad8184820dfd.svg";
export { ForwardRef as ReactComponent };